import React from "react";
import { useTranslate } from 'react-redux-multilingual';
import { OverlayTrigger, Tooltip } from "react-bootstrap";

// Style import
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';

const  BtnAcquitteFacture = (props) => {
    const t = useTranslate();

    const handleClick = () => {
        props.setShowPaymentForm(props.allInfos)
        props.setShowModalPaymentForm(true)
    }

    return (
        <OverlayTrigger
            placement="bottom"
            overlay={
                <Tooltip id={`tooltip-${props.index}`}>
                    {t('addSettle')}
                </Tooltip>
            }
        >
            <span onClick={() => handleClick()} style={{cursor:'Pointer', color:'#ff00ff'}}><FontAwesomeIcon icon={faFileInvoiceDollar} /></span>
        </OverlayTrigger>  
    )
}

export default BtnAcquitteFacture;